// extracted by mini-css-extract-plugin
export default {"userPaneTextRole":"Overview_userPaneTextRole__JIOU7","userPaneTextName":"Overview_userPaneTextName__FNC14","description":"Overview_description__KGyZK"};